import { STATISTICS_STATE_KEY } from './statistics-reducer';

export const getOfficesLoading = (state) => state[STATISTICS_STATE_KEY]?.officesLoading;
export const getDoctorsLoading = (state) => state[STATISTICS_STATE_KEY]?.doctorsLoading;
export const getActivityLoading = (state) => state[STATISTICS_STATE_KEY]?.activityLoading;

export const getOfficesData = (state) => state[STATISTICS_STATE_KEY]?.officesData;
export const getDoctorsData = (state) => state[STATISTICS_STATE_KEY]?.doctorsData;
export const getActivityData = (state) => state[STATISTICS_STATE_KEY]?.activityData;
